// Redux custom middleware

/**
 * Simple auth middleware - detects auth failures and can be extended to
 * dispatch sign-out / token-refresh or redirect-to-login logic.
 * Customize this to integrate your app's auth flow.
 */
const authMiddleware = (store) => (next) => (action) => {
  // Example: detect Axios-style 401 errors on rejected actions
  try {
    if (action?.error?.name === 'AxiosError' && action?.error?.response?.status === 401) {
      // TODO: dispatch a signOut action or trigger token refresh
      // e.g. store.dispatch({ type: 'auth/signOut' });
      console.warn('authMiddleware: detected 401 response');
    }
  } catch (e) {
    // swallow errors from middleware detection
  }
  return next(action);
};

/**
 * Logger middleware - logs actions and state in development
 */
const loggerMiddleware = (store) => (next) => (action) => {
  if (process.env.NODE_ENV !== 'production') {
    try {
      console.groupCollapsed(`[redux] action: ${action.type}`);
      console.log('prev state', store.getState());
      console.log('action', action);
    } catch (e) {
      // ignore logging errors
    }
  }

  const result = next(action);

  if (process.env.NODE_ENV !== 'production') {
    try {
      console.log('next state', store.getState());
      console.groupEnd();
    } catch (e) {
      // ignore
    }
  }

  return result;
};

export { authMiddleware, loggerMiddleware };